module.exports = __webpack_public_path__ + "media/images/edit-104bf02c6a616d81c922c74108edf1f5.svg";